import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/hud-fair-market-rents")({
  component: () => <Outlet />,
});
